const screenReducer = (screen = 1, action) => {
    switch(action.type) {
        case 'SET_SCREEN':
            return action.payload;
        default:
            return screen;
    }
};

export default screenReducer;